import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

const getOperatorDataFromRedux = function(state:RootState) {
    return state.operator;
  };

export const getOperatorDetail = createSelector(getOperatorDataFromRedux,(operator)=> operator);
export const  getOperatorDetails = createSelector(getOperatorDetail,(operator)=>{
    const transformedData = operator?.operators?.data?.map((operator)=>({
        ...operator,
        provider:{
            id: operator.provider.providerId,
            name: operator.provider.name
        },
        subapplication:{
            id: operator.subapplication.id,
            name: operator.subapplication.name
        }
    }))
    return transformedData
} )

export const getOperatorList = createSelector(getOperatorDataFromRedux,(operator)=>{
    const listOperator = operator?.operators?.data?.map((operator)=>({
        id: operator?.operatorId,
        name: operator?.name
    }))
    return listOperator
})


export const getOperatorListErrorDetails = createSelector(getOperatorDataFromRedux,(operatorData)=>{
    const operatorsListErrorData = {
        error: operatorData?.error,
        message:`Operator : ${operatorData?.message}`
    }
return operatorsListErrorData
})